<template>
    <div class="az-pagination paginacao">
        <v-pagination
            v-if="mostrarPaginas"
            v-model="paginacaoInterna.page"
            total-visible="7"
            :length="paginas"
            @input="mudarPagina"
            class="pt-3"/>
        <v-spacer v-if="!mostrarPaginas"/>
        <div v-if="mostrarLinhasPorPagina" class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.rowsPerPage"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Paginacao',
        props: {
            paginacaoInterna: {
                type: Object,
                required: true
            },
            paginas: {
                type: Number,
                required: true
            },
            linhasPorPagina: {
                type: Array,
                default: () => {
                    return [10, 25, 50, 100]
                }
            },
            totalItens: {
                type: Number,
                required: true
            }
        },
        computed: {
            mostrarPaginas () {
                return this.paginas > 1
            },
            mostrarLinhasPorPagina () {
                return this.totalItens > this.linhasPorPagina[0]
            }
        },
        methods: {
            resetaPage() {
                this.$emit('resetaPage')
            },
            mudarPagina() {
                this.$emit('aoMudarPagina', this.paginacaoInterna)
            }
        }
    }
</script>

<style scoped lang="stylus">
    .paginacao
        height 50px !important

    .az-pagination >>> .v-pagination__item
        width 41px !important
</style>
